import { ApiResponse, MonthlyRevenueTarget } from "../types";
import { apiClient } from "./apiClient";

export const revenueTargetsApi = {
  async get(
    month: number,
    year: number
  ): Promise<ApiResponse<MonthlyRevenueTarget | null>> {
    return apiClient.get(
      `/revenue-targets?month=${month}&year=${year}`
    );
  },

  async listYear(year: number): Promise<ApiResponse<MonthlyRevenueTarget[]>> {
    return apiClient.get(`/revenue-targets/year?year=${year}`);
  },

  async upsert(params: {
    month: number;
    year: number;
    amount: number;
  }): Promise<ApiResponse<MonthlyRevenueTarget>> {
    return apiClient.put("/revenue-targets", params);
  },

  async remove(
    month: number,
    year: number
  ): Promise<ApiResponse<{ deleted: boolean }>> {
    return apiClient.delete(
      `/revenue-targets?month=${month}&year=${year}`
    );
  },
};
